export class State {
    error = {};
    success = {};
    isLoading = false;
    dataList = [];
    dataItem = {};
}
